<template>
  <div class="main-wrapper">
    <layout-header class="no-print"></layout-header>
    <layout-sidebar class="no-print"></layout-sidebar>
    <div class="page-wrapper">
      <div class="content container-fluid">

        <GenericTabs
          :activeTab="activeTab"
          :tabs="invoiceTabs"
          :modules="modules"
          :permissions="permissions"
          :locale="$i18n.locale"
        />

        <div ref="formContainer" class="row print">
          <div class="col-md-12">
            <div class="row">
              <div class="col-lg-9 mb-5" v-if="invoice && retrievedInvoice" ref="invoiceContainer">
                <div v-if="!isLoading" class="card printBoarder" id="printMe" ref="printMe">
                  <div class="card-header pb-4" v-if="!pos">
                    <div class="row mt-3 pt-3">
                      <div class="col-md-6 col-sm-12" v-if="invoice.sender">
                        <div v-if="logoUrl" class="mb-4">
                          <img class="preview img-fluid" :src="logoUrl" alt="" style="max-width: 180px;"/>
                        </div>
                        <div>
                          <span style="font-weight: bold">{{
                              invoice.sender.company && invoice.sender.company.toUpperCase()
                            }}</span>
                        </div>
                        <div>
                          <span class="pre-line">{{ invoice.sender.address }}</span>
                        </div>
                        <div>
                          <span>{{ invoice.sender.email }}</span>
                        </div>
                        <div>
                          <span>{{ invoice.sender.phone }}</span>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12 pull-left quote-header">
                        <div class="row">
                          <div class="col-md-12 col-sm-6">
                            <h2 id="docName" v-if="isExporting" class="text-right mr-3"
                                style="font-family: 'Gill Sans',serif; font-weight: bolder"> {{
                                invoice.labels.name
                              }}</h2>
                            <h2 v-if="!isExporting" class="text-left mr-5 w101">
                              <label readonly="readonly" type="text"
                                     class="input text-right w99"
                                     style="font-family: 'Gill Sans',serif; font-weight: bolder">{{
                                  invoice.labels.name
                                }}</label>
                            </h2>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row mt-3 mb-0">
                      <div class="col-md-4 col-sm-12 mt-3">
                        <table class="tblInvoiceHeaderDetails table table-hover table-center mb-0 datatable"
                               v-if="retrievedInvoice.customer">
                          <tbody>
                          <tr class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); font-weight: bold">
                            <td class="text-left">To:</td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left" v-if="retrievedInvoice.customer">
                              <a :href="'/customers/' + customer.id" class="text-decoration-none text-dark">
                                {{ retrievedInvoice.customer.name || retrievedInvoice.customer.number }}
                              </a>
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left"
                                v-if="retrievedInvoice.customer.address === null && retrievedInvoice.customer.email">
                              {{ retrievedInvoice.customer.email }}
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left"
                                v-if="retrievedInvoice.customer.address === null && retrievedInvoice.customer.phone">
                              {{ retrievedInvoice.customer.phone }}
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left"><span class="pre-line">{{ retrievedInvoice.customer.address }}</span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-4 col-sm-12 mt-3">
                        <table class="tblInvoiceHeaderDetails table table-hover table-center mb-0 datatable"
                               v-if="retrievedInvoice.customer && retrievedInvoice.deliveryAddress">
                          <tbody>
                          <tr class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); font-weight: bold">
                            <td class="text-left">Ship To:</td>
                          </tr>
                          <tr v-if="retrievedInvoice.deliveryAddress" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left"><span class="pre-line">{{ retrievedInvoice.deliveryAddress }}</span>
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left"
                                v-if="retrievedInvoice.customer.address === null && retrievedInvoice.customer.email">
                              {{ retrievedInvoice.customer.email }}
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left"
                                v-if="retrievedInvoice.customer.address === null && retrievedInvoice.customer.phone">
                              {{ retrievedInvoice.customer.phone }}
                            </td>
                          </tr>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left"><span class="pre-line">{{ retrievedInvoice.customer.address }}</span>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="col-md-4 col-sm-12 mt-3">
                        <table class="tblInvoiceHeaderDetails table table-hover table-center mb-0 datatable ">
                          <tbody>
                          <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left" style="font-weight: bold">Invoice:</td>
                            <td class="text-right">{{ retrievedInvoice.invoiceNumber }}</td>
                          </tr>
                          <tr v-if="retrievedInvoice.currency" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Currency:</td>
                            <td class="text-right">{{ retrievedInvoice.currency }}</td>
                          </tr>
                          <tr v-if="retrievedInvoice.rate" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Rate:</td>
                            <td class="text-right">{{ (retrievedInvoice.rate / 100).toFixed(2) }}</td>
                          </tr>
                          <tr v-if="retrievedInvoice.date" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Invoice Date:</td>
                            <td class="text-right">{{ getDate(retrievedInvoice.date) }}</td>
                          </tr>
                          <tr v-if="retrievedInvoice.dueDate" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Due Date:</td>
                            <td class="text-right">{{ getDate(retrievedInvoice.dueDate) }}</td>
                          </tr>
                          <tr v-if="retrievedInvoice.dateCreated" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);" hidden>
                            <td class="text-left">Created:</td>
                            <td class="text-right">{{ getDate(retrievedInvoice.dateCreated) }}</td>
                          </tr>
                          <tr v-if="retrievedInvoice.orderId" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">QT/SO No.:</td>
                            <td class="text-right">{{ retrievedInvoice.orderId }}</td>
                          </tr>
                          <tr v-if="retrievedInvoice.projectName" class="text-right borderless"
                              style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                            <td class="text-left">Project:</td>
                            <td class="text-right">{{ retrievedInvoice.projectName }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  <div class="card-body pt-2">
                    <div class="table">
                      <div>
                        <table id="tblItems" class="table table-hover table-center mb-0 datatable"
                               v-bind:class="windowWidth < 768 ? 'cards' : ''">
                          <thead style="background-color: #666; color: white" id="items-header">
                          <tr class="text-center">
                            <th scope="col" class="text-left col-md-6">Description</th>
                            <th scope="col" class="text text-center">Qty</th>
                            <th scope="col" class="text text-center">Price</th>
                            <th scope="col" class="text text-center">Amount</th>
                            <th scope="col" class="text text-center">Disc</th>
                            <th scope="col" class="text text-center">Tax</th>
                            <th scope="col" class="text text-right">Total</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr style="background-color: white" class="text-center"
                              v-for="invoiceLine in retrievedInvoice.invoiceItems" :key="invoiceLine.productId">
                            <td col="Description: " class="description-mobile col-md-6"
                                style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{ invoiceLine.name }}
                              </span>
                            </td>
                            <td col="Qty: " class="title-mobile" style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{ invoiceLine.quantity }}
                              </span>
                            </td>
                            <td col="Price: " class="title-mobile"
                                style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{ invoiceLine.amount ? (invoiceLine.amount / 100).toFixed(2) : 0.00.toFixed(2) }}
                              </span>
                            </td>
                            <td col="Amount: " class="title-mobile"
                                style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{ invoiceLine.subTotal ? (invoiceLine.subTotal / 100).toFixed(2) : 0.00.toFixed(2) }}
                              </span>
                            </td>
                            <td col="Disc: " class="title-mobile" style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{
                                  invoiceLine.totalDiscount ? (invoiceLine.totalDiscount / 100).toFixed(2) : 0.00.toFixed(2)
                                }}
                              </span>
                            </td>
                            <td col="Tax: " class="title-mobile" style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{ invoiceLine.totalTax ? (invoiceLine.totalTax / 100).toFixed(2) : 0.00.toFixed(2) }}
                              </span>
                            </td>
                            <td col="Total: " class="total-mobile"
                                style="padding-top: 0.35rem; padding-bottom: 0.35rem">
                              <span>
                                {{ invoiceLine.total ? (invoiceLine.total / 100).toFixed(2) : 0.00 }}
                              </span>
                            </td>
                          </tr>
                          </tbody>
                        </table>

                        <hr style="margin-bottom: 0.3em; margin-top: 0.3em"/>

                        <div class="row mb-0">
                          <div class="col-md-4 col-sm-12"></div>
                          <div class="col-md-4 col-sm-12"></div>
                          <div class="col-md-4 col-sm-12">
                            <table class="tblPayments table table-hover table-center mb-0 datatable ">
                              <tbody>
                              <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                                <td class="text-left">Sub Total</td>
                                <td class="text-right">
                                  {{
                                    retrievedInvoice.currency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedInvoice.currency
                                    }).format(retrievedInvoice.subTotal ? (retrievedInvoice.subTotal / 100).toFixed(2) : 0.00) : '-'
                                  }}
                                </td>
                              </tr>
                              <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                                <td class="text-left">Discount</td>
                                <td class="text-right">{{
                                    retrievedInvoice.currency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedInvoice.currency
                                    }).format(retrievedInvoice.totalDiscount ? (retrievedInvoice.totalDiscount / 100).toFixed(2) : 0.00) : '-'
                                  }}
                                </td>
                              </tr>
                              <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                                <td class="text-left">Tax</td>
                                <td class="text-right">{{
                                    retrievedInvoice.currency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedInvoice.currency
                                    }).format(retrievedInvoice.totalTax ? (retrievedInvoice.totalTax / 100).toFixed(2) : 0.00) : '-'
                                  }}
                                </td>
                              </tr>
                              <tr class="text-right borderless"
                                  style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); font-weight: bold">
                                <td class="text-left">Total</td>
                                <td class="text-right">{{
                                    retrievedInvoice.currency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedInvoice.currency
                                    }).format(retrievedInvoice.total ? (retrievedInvoice.total / 100).toFixed(2) : 0.00) : '-'
                                  }}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                            <hr v-if="retrievedInvoice.payments && retrievedInvoice.payments.length"
                                style="margin-bottom: 0.3em; margin-top: 0.3em"/>
                            <table v-if="retrievedInvoice.payments && retrievedInvoice.payments.length"
                                   class="tblPayments table table-hover table-center mb-0 datatable">
                              <tbody>
                              <tr class="text-right borderless" style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);">
                                <td class="text-left">Paid</td>
                                <td class="text-right">{{
                                    retrievedInvoice.currency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedInvoice.currency
                                    }).format(retrievedInvoice.amountPaid ? (retrievedInvoice.amountPaid / 100).toFixed(2) : 0.00) : '-'
                                  }}
                                </td>
                              </tr>
                              <tr hidden class="text-right borderless"
                                  style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0);"
                                  v-for="payment in retrievedInvoice.payments" :key="payment.id">
                                <td class="text-left">
                                  {{ payment.paymentMethod && payment.paymentMethod.description || '-' }}
                                </td>
                                <td class="text-right">{{
                                    payment.paymentCurrency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: payment.paymentCurrency
                                    }).format(payment.paymentAmount) : '-'
                                  }}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                            <hr style="margin-bottom: 0.3em; margin-top: 0.3em"/>
                            <table class="tblPayments table table-hover table-center mb-0 datatable">
                              <tbody>
                              <tr class="text-right borderless"
                                  style="border: 0; border-bottom: 0 rgba(0, 0, 0, 0); font-weight: bold; background-color: #f5f5f5">
                                <td class="text-left">Balance Due</td>
                                <td class="text-right">{{
                                    retrievedInvoice.currency ? new Intl.NumberFormat('en-ZA', {
                                      style: 'currency',
                                      currency: retrievedInvoice.currency
                                    }).format(retrievedInvoice.balance ? (retrievedInvoice.balance / 100).toFixed(2) : 0.00) : '-'
                                  }}
                                </td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="retrievedInvoice.notes" class="row mt-0" id="termsAndConditions">
                      <div class="col-12">
                        <label class="form-label me-1"></label>
                        <span class="show-footer-label-modal text-decoration-dotted form-label">
                          <label readonly="readonly" class="w101 bold" type="text"
                                 style="height: 35px; font-weight: bold; margin-bottom: 0px;">Notes:</label>
                        </span>
                        <span class="white-space pre-line">
                          {{ retrievedInvoice.notes }}
                        </span>
                      </div>
                    </div>
                    <div v-if="!isExporting"
                         style="overflow-y: auto; min-height: calc(100vh - 500px) !important;"></div>
                  </div>
                  <div hidden class="card-footer">
                  </div>
                </div>
                <template v-else>
                  <DocumentSkeleton :rows="10" :columns="6"/>
                </template>
              </div>
              <div class="col-lg-3 no-print">
                <ViewInvoiceSidebar
                  :is-loading="isLoading"
                  :retrieved-invoice="retrievedInvoice"
                  :permissions="permissions"
                  @loading="changeLoadingState"
                  @updated="invoiceUpdated"
                  @medical-aid-payment-added="onMedicalAidPaymentAdded"
                />
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js/src";

import invoiceService from "../../service/invoice.service";
import fileService from "../../service/file.service";
import storeService from "../../service/store.service";
import {base64StringToBlob} from "blob-util";
import moment from "moment";
import process from "shelljs";
import {getConfig} from "../../utils/config"
import {viewInvoiceTabs} from "../../utils/utils";
import {allowedModules} from "../../utils/modules";
import GenericTabs from "../shared/GenericTabs";
import ViewInvoiceSidebar from "./ViewInvoiceSidebar";
import DocumentSkeleton from "../shared/DocumentSkeleton";
import {handleError} from "../../utils/notification.utils";

export default {
  name: "ViewInvoiceOffline",
  components: {
    GenericTabs,
    ViewInvoiceSidebar,
    DocumentSkeleton,
  },
  data() {
    return {
      store: null,
      permissions: {},
      pagePermissions: ['INVOICE_CREATE', 'INVOICE_READ', 'INVOICE_PAYMENT_CREATE', 'INVOICE_PRINT', 'INVOICE_DOWNLOAD', 'INVOICE_CANCEL', 'INVOICE_DELETE', 'INVOICE_EMAIL', 'INVOICE_PAYMENT_READ', 'INVOICE_UPDATE'],
      displayDisabledButtons: !getConfig().hideIfNoPermission,
      pos: false,
      isLoading: false,
      isExporting: false,
      retrievedInvoice: {
        id: null,
        invoiceNumber: null
      },
      customer: {
        id: null,
        fullName: null
      },
      invoice: {
        number: "",
        date: moment(new Date()).format('DD-MM-YYYY'),
        dueDate: moment(new Date()).add(15, 'days').format('DD-MM-YYYY'),
        reference: "CUS-22",
        currency: "USD",
        images: {
          logo: "https://public.salesdue.cloud/img/logo_en_original.png",
          background: "https://public.salesdue.cloud/img/watermark-draft.jpg"
        },
        sender: {
          company: undefined,
          address: undefined,
          zip: undefined,
          city: undefined,
          country: undefined,
          email: undefined,
          phone: undefined
        },
        client: {
          name: "",
          address: "",
          zip: "",
          city: "",
          country: "",
          email: "",
          phone: ""
        },
        products: [],
        termsAndConditions: "",
        settings: {
          taxNotation: "vat",
          marginTop: 25,
          marginRight: 25,
          marginLeft: 25,
          marginBottom: 25
        },
        labels: {
          name: "INVOICE",
          billTo: "To:"
        },
        status: "DRAFT",
        subTotal: 0.00,
        totalTax: 0.00,
        amountPaid: 0.00,
        balance: 0.00,
        total: 0.00
      },
      selectedPaymentMethodId: "CASH",
      paymentMethods: [],
      currencies: ["USD", "ZWL"],
      selectedCurrencyId: "",
      rate: 1.00,
      payment: {
        id: "",
        method: "",
        currency: "",
        amount: 0.00,
        date: undefined,
        reference: 0.00
      },
      currentPage: 1,
      totalPages: 0,
      totalRecords: 0,
      recordsPerPage: 10,
      printReceipt: true,
      orders: [],
      invoices: [],
      logoUrl: undefined,
      showDeleteInvoiceButton: process.env.SHOW_DELETE_INVOICE_BUTTON,
      isMobileView: false,
      isTabletView: false,
      isDesktopView: false,
      activeTab: 'view-invoice',
      modules: [],
      invoiceTabs: [],
    }
  },
  watch: {
    'invoice.products': {
      handler(beforeVal, afterVal) {
        this.calculateInvoice()
      },
      deep: true,
      immediate: true
    },
    windowWidth: function () {
      if (this.windowWidth < 768) {
        this.isMobileView = true
      }
      if (this.windowWidth >= 768 && this.windowWidth <= 1200) {
        this.isTabletView = true
      }
      if (this.windowWidth > 1200) {
        this.isDesktopView = true
      }
    },
  },
  computed: {
    cartTotal() {
      return this.invoice.total
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
    windowWidth() {
      return this.$store.state.app.windowWidth;
    },
    basedOnWindowWidth() {
      if (this.windowWidth > 768) {
        return true;
      }
      return false;
    }
  },
  methods: {
    hasPermission(permission) {
      return this.permissions[permission]
    },
    showButtonFor(permission) {
      if (this.hasPermission(permission)) {
        return true
      } else {
        return this.displayDisabledButtons
      }
    },
    isDisabledFor(permission) {
      return !this.hasPermission(permission)
    },
    buttonTooltip(permission) {
      return this.isDisabledFor(permission) ? 'You do not have access to this feature' : ''
    },
    getCurrentDate() {
      const currentDate = new Date();
      const year = currentDate.getFullYear();
      const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
      const day = currentDate.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`
    },
    formatDateTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm")
    },


    changeLoadingState(isLoading) {
      this.isLoading = isLoading;
    },
    onMedicalAidPaymentAdded() {
      this.retrieveInvoice(this.invoiceId);
    },
    invoiceUpdated(updatedInvoice) {
      if (updatedInvoice) {
        this.retrievedInvoice = updatedInvoice;
      } else {
        this.retrieveInvoice(this.invoiceId);
      }
    },







    getDate(stringDate) {
      const date = moment(stringDate);
      return date.format("DD-MM-YYYY")
    },
    deleteInvoice(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          invoiceService.delete(id)
            .then(response => {
              if (response.data.success === true) {
                Swal.fire({
                  icon: 'success',
                  title: 'Deleted',
                  text: "Successfully deleted invoice",
                  footer: '<a href="">Why do I have this issue?</a>'
                })
                this.$router.push('/invoices');
              } else {
                Swal.fire({
                  icon: 'warning',
                  title: 'Failed',
                  text: response.data.narrative,
                  footer: '<a href="">Why do I have this issue?</a>'
                })
              }
            })
            .catch(e => {
              if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                return
              }
              Swal.fire({
                icon: 'warning',
                title: 'Oops...',
                text: "Can't delete invoice",
                footer: '<a href="">Why do I have this issue?</a>'
              })
            });
        }
      })
    },
    async retrieveInvoice(id) {
      this.isLoading = true;
      await invoiceService.findById(id)
        .then(response => {
          if (response && response.data) {
            this.retrievedInvoice = response.data;
            if (this.retrievedInvoice && this.retrievedInvoice.payments) {
              this.retrievedInvoice.payments.sort((a, b) => Date.parse(b.dateCreated) - Date.parse(a.dateCreated))
            }
            if (this.retrievedInvoice && this.retrievedInvoice.invoiceItems) {
              this.retrievedInvoice.invoiceItems.sort((a, b) => a.lineNumber - b.lineNumber)
            }
            // Retrieve logo and store details using merchantId from invoice
            if (this.retrievedInvoice.merchantId) {
              this.retrieveLogo(this.retrievedInvoice.merchantId);
              this.retrieveStore(this.retrievedInvoice.merchantId);
            }
          }
        })
        .catch(e => {
          handleError(e);
        })
        .finally(() =>
          this.isLoading = false
        );
    },
    retrieveLogo(merchantId) {
      if (!merchantId) {
        console.log('No merchantId provided for logo retrieval');
        return;
      }
      fileService.fetchLogo(merchantId)
        .then(response => {
          if (!response) {
            return;
          }
          if (response && response.data.success === true) {
            const contentType = 'image/png';
            const blob = base64StringToBlob(response.data.data.bytes, contentType);
            this.logoUrl = URL.createObjectURL(blob);
          }
        })
        .catch(e => {
          console.log('Failed to retrieve logo:', e);
          // Don't show error notification for logo - it's not critical
        });
    },
    retrieveStore(merchantId) {
      if (!merchantId) {
        console.log('No merchantId provided for store retrieval');
        return;
      }
      storeService.findById(merchantId, merchantId)
        .then(response => {
          if (!response || !response.data) {
            return;
          }
          this.store = response.data.data;
          // Update invoice sender details with store information
          if (this.store) {
            this.invoice.sender.company = this.store.name;
            this.invoice.sender.email = this.store.email || this.invoice.sender.email;
            this.invoice.sender.phone = this.store.phone || this.invoice.sender.phone;
            this.invoice.sender.address = this.store.address || this.invoice.sender.address;
          }
        })
        .catch(e => {
          console.log('Failed to retrieve store details:', e);
          // Don't show error notification for store - it's not critical
        });
    },



    calculateLineTotal(product) {
      return product.price * product.quantity
    },
    calculateInvoice() {
      let total = 0.00
      for (let i = 0; i < this.invoice.products.length; i++) {
        let product = this.invoice.products[i]
        let subTotal = product.price * product.quantity
        product.subTotal = subTotal
        total = total + subTotal
      }
      this.invoice.total = total
    },
    exportToPDF() {
      localStorage.setItem("viewInvoice", JSON.stringify(this.invoice))
      this.isExporting = true
      let invoiceDoc = this.retrievedInvoice
      const doc = document.body;
      const body = document.body.cloneNode(true);
      let element = document.getElementById('printMe');
      element.classList.add('print');
      element.style.border = "none";
      if (invoiceDoc.termsAndConditions === '') {
        let el = document.getElementById('termsAndConditions')
        if (el) {
          el.style.display = "none";
        }
      }
      if (this.invoice.currency === '') {
        let el = document.getElementById('currency')
        el.style.display = "none";
      }
      $(':input[type="text"]').filter(function (e) {
        if (this.value.length === 0) {
          return true;
        }
      }).hide();
      let opt = {
        margin: 0,
        filename: this.retrievedInvoice.invoiceNumber,
        html2canvas: {
          scale: 2,
          windowWidth: 1024
        },
      }
      html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
        this.isExporting = false
        document.body = body;
        window.location.reload()
      }).save();
    },

    exportToPDFF() {
      localStorage.setItem("viewInvoice", JSON.stringify(this.invoice))
      this.isExporting = true
      let invoiceDoc = this.invoice
      const body = document.body.cloneNode(true);
      let element = document.getElementById('printMe');
      element.classList.add('print');
      element.style.border = "none";
      if (this.retrievedInvoice.termsAndConditions === '') {
        let el = document.getElementById('termsAndConditions')
        if (el) {
          el.style.display = "none";
        }
      }
      if (this.retrievedInvoice.currency === '') {
        let el = document.getElementById('currency')
        el.style.display = "none";
      }
      $(':input[type="text"]').filter(function (e) {
        if (this.value.length === 0) {
          return true;
        }
      }).hide();
      let opt = {
        margin: 0,
        filename: this.retrievedInvoice.invoiceNumber,
        html2canvas: {
          scale: 2,           // higher quality
          windowWidth: 1024   // simulate a browser size that causes the page's responsive CSS to output a pleasing layout in the rendered PDF
        },
        // pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
      }

      // const pages = []
      // pages.push(element)
      // pages.push(element)
      // exportHTMLToPDF(pages).then((doc)=>{
      //   var blobPDF =  new Blob([ doc ], { type : 'application/pdf'});
      //   var blobUrl = URL.createObjectURL(blobPDF);  //<--- THE ERROR APPEARS HERE
      //
      //   window.open(blobUrl);
      // })

      // html2pdf().from(element).set(opt).save().then((doc)=>{
      //
      //   this.isExporting = false
      //   document.body = body;
      //   element.classList.remove('print');
      //   window.location.reload()
      //   this.invoice = invoiceDoc
      // })

      html2pdf().from(element).set(opt).toPdf().get('pdf').then(function (pdf) {
        // var pageCount = pdfObj.internal.get();
        // console.log('pageCount', pdfObj.internal.pageSize.height)

        var totalPages = pdf.internal.getNumberOfPages() / 2.4;
        for (var i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
        }
      }).save();

      // pdfObj.deletePage(pageCount)
      // this.isExporting = false
      // document.body = body;
      // pdfObj.autoPrint();
      // window.open(pdfObj.output('bloburl'), '_blank');
      // window.location.reload()


      // html2pdf().from(element).set({
      //   margin:       [1, 0, 0, 0],
      //   filename: 'samplepdf.pdf',
      //   pageBreak: { mode: 'css', before:'#nextpage1'},
      //   jsPDF: {orientation: 'landscape', unit: 'in', format: 'letter'}
      // }).toPdf().get('pdf').then(function (pdf) {
      //   var totalPages = pdf.internal.getNumberOfPages();
      //   for (var i = 1; i <= totalPages; i++) {
      //     pdf.setPage(i);
      //     pdf.setFontSize(10);
      //     pdf.setTextColor(150);
      //   }}).save();

    },
    sendViaEmail() {
      this.$router.push(`/invoices/${this.invoiceId}/email`);
    },
    sendInvoiceViaEmail(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#008000',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, send it!'
      }).then((result) => {
        if (result.isConfirmed) {
          return new Promise((resolve, reject) => {
            invoiceService.sendViaEmail(id, {})
              .then(response => {
                if (response.data.success === true) {
                  Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: "Successfully sent invoice via email",
                    footer: '<a href=""></a>'
                  })
                  this.retrievedInvoice = response.data.data
                  this.viewInvoice(response.data.data.id)
                  return resolve("success")
                } else {
                  Swal.fire({
                    icon: 'info',
                    title: 'Failed',
                    text: response.data.narrative,
                    footer: '<a href=""></a>'
                  })
                  return reject(response.data.narrative)
                }
              })
              .catch(e => {
                handleError(e);
                return reject("Error occurred whilst sending invoice via email")
              })
              .finally(() => {
              })
          })
        }
      })
    },
    payOrderOnline() {
      const currentUrl = window.location.href;
      const returnUrl = encodeURIComponent(currentUrl)
      const url = `${process.env.PAYMENT_GATEWAY_URL}?amount=${this.retrievedInvoice.balance * 100}&currency=${this.retrievedInvoice.currency}&reference=${this.retrievedInvoice.id}&mid=${localStorage.getItem('mid')}&returnUrl=${returnUrl}`
      window.open(url, "_self");
    },

    sendInvoiceViaEmailFE() {
      localStorage.setItem("viewInvoice", JSON.stringify(this.invoice))
      if (this.retrievedInvoice.customer || this.retrievedInvoice.customer.email) {
        this.isExporting = true
        const invoiceDoc = this.retrievedInvoice
        const router = this.$router
        const store = this.store;
        const body = document.body.cloneNode(true);
        let element = document.getElementById('printMe');
        element.classList.add('print');
        element.style.border = "none";
        if (this.invoice.termsAndConditions === '') {
          let el = document.getElementById('termsAndConditions')
          if (el) {
            el.style.display = "none";
          }
        }
        if (this.invoice.currency === '') {
          let el = document.getElementById('currency')
          el.style.display = "none";
        }
        $(':input[type="text"]').filter(function (e) {
          if (this.value.length === 0) {
            return true;
          }
        }).hide();
        let opt = {
          margin: 0,
          filename: this.retrievedInvoice.number,
          html2canvas: {
            scale: 2,           // higher quality
            windowWidth: 1024   // simulate a browser size that causes the page's responsive CSS to output a pleasing layout in the rendered PDF
          },
        }
        html2pdf().from(element).set(opt).toPdf().output('datauristring').then(function (pdfAsString) {
          const arr = pdfAsString.split(',');
          const stringInvoice = arr[1];
          localStorage.setItem("base64Invoice", stringInvoice)
        })
        const base64EmailProps = {
          invoiceNumber: invoiceDoc.invoiceNumber,
          storeName: store.name,
          to: invoiceDoc.customer.email,
          subject: "Invoice [" + invoiceDoc.invoiceNumber + "]"
        }
        localStorage.setItem("base64EmailProps", JSON.stringify(base64EmailProps))
        router.push(`/invoices/${invoiceDoc.id}/email`)
      } else {
        Swal.fire({
          icon: 'warning',
          text: 'Customer email is required',
          footer: '<a href="">Need help?</a>'
        })
      }
    },
    invoiceStatus(status) {
      if (status === 'Paid') {
        return 'badge-success bg-success-light'
      } else if (status === 'Partially Paid') {
        return 'badge-warning bg-warning-light'
      } else if (status === 'Not Paid') {
        return 'badge-danger bg-danger-light'
      } else {
        return 'badge-secondary bg-secondary-light'
      }
    },
    addInvoiceLine() {
      let price = (Math.round(0.00).toFixed(2));
      let invoiceLine = {
        sku: "",
        quantity: "1",
        description: "",
        price: price,
        subTotal: 1.00
      }
      this.invoice.products.push(invoiceLine)
    },
    deleteItem(product, index) {
      this.invoice.products.splice(index, 1);
    },
    saveRemoteInvoice() {
      this.fireNotification("warning", "", "Sign up to continue", "#", "Sign Up")
    },
    sendInvoiceViaWhatsapp() {
      this.fireNotification("warning", "", "Sign up to continue", "#", "Sign Up")
    },
    async printInvoice() {
      const prtHtml = document.getElementById('printMe').innerHTML;
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            ${prtHtml}
          </body>
        </html>`
      );
      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      // WinPrint.close();
    },
    fireNotification(icon, title, message, footerLink, footerText) {
      Swal.fire({
        icon: 'warning',
        text: message,
        footer: '<a href="">Why am I getting this?</a>'
      })
    },
    approveInvoice(id) {
      if (id) {
        return new Promise((resolve, reject) => {
          invoiceService.approve(id)
            .then(response => {
              if (response.data.id) {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: "Successfully updated invoice",
                  footer: '<a href=""></a>'
                })
                this.retrievedInvoice = response.data
                this.viewInvoice(response.data.id)
                return resolve("success")
              } else {
                Swal.fire({
                  icon: 'info',
                  title: 'Failed',
                  text: response.data.narrative,
                  footer: '<a href=""></a>'
                })
                return reject(response.data.narrative)
              }
            })
            .catch(e => {
              if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                return
              }
              return reject("Error occurred 9")
            })
            .finally(() => {
            })
        })
      }
    },
    markInvoiceAsNotTaxable(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
      }).then((result) => {
        if (result.isConfirmed) {
          if (id) {
            const data = {
              taxable: false
            }
            return new Promise((resolve, reject) => {
              invoiceService.update(id)
                .then(response => {
                  if (response.data.id) {
                    Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: "Successfully updated",
                      footer: '<a href=""></a>'
                    })
                    this.retrievedInvoice = response.data
                    this.$router.push("/invoices")
                    return resolve("success")
                  } else {
                    Swal.fire({
                      icon: 'info',
                      title: 'Failed',
                      text: response.data.narrative,
                      footer: '<a href=""></a>'
                    })
                    return reject(response.data.narrative)
                  }
                })
                .catch(e => {
                  if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                    return
                  }
                  return reject("Error occurred 9")
                })
                .finally(() => {
                })
            })
          }
        }
      })
    },
    reconcileInvoice(id) {
      if (id) {
        return new Promise((resolve, reject) => {
          invoiceService.reconcile(id)
            .then(response => {
              if (response.data.success) {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: "Successfully updated invoice",
                  footer: '<a href=""></a>'
                })
                this.retrievedInvoice = response.data.data
                this.viewInvoice(this.retrievedInvoice.id)
                return resolve("success")
              } else {
                Swal.fire({
                  icon: 'info',
                  title: 'Failed',
                  text: response.data.narrative,
                  footer: '<a href=""></a>'
                })
                return reject(response.data.narrative)
              }
            })
            .catch(e => {
              if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                return
              }
              return reject("Error occurred 9")
            })
            .finally(() => {
            })
        })
      }
    },

    cloneInvoice(id) {
      if (id) {
        return new Promise((resolve, reject) => {
          invoiceService.clone(id)
            .then(response => {
              if (response.data.id) {
                Swal.fire({
                  icon: 'success',
                  title: 'Success',
                  text: "Successfully clone document",
                  footer: '<a href=""></a>'
                })
                this.retrievedInvoice = response.data
                this.$router.push(`/invoices/${response.data.id}`)
                return resolve("success")
              } else {
                Swal.fire({
                  icon: 'info',
                  title: 'Failed',
                  text: response.data.narrative,
                  footer: '<a href=""></a>'
                })
                return reject(response.data.narrative)
              }
            })
            .catch(e => {
              if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                return
              }
              return reject("Error occurred 9")
            })
            .finally(() => {
            })
        })
      }
    },
    cancelInvoice(id) {
      Swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#ffc107',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, cancel it!'
      }).then((result) => {
        if (result.isConfirmed) {
          if (id) {
            return new Promise((resolve, reject) => {
              invoiceService.cancel(id)
                .then(response => {
                  if (response.data.success) {
                    Swal.fire({
                      icon: 'success',
                      title: 'Success',
                      text: "Successfully cancelled invoice",
                      footer: '<a href=""></a>'
                    })
                    this.retrievedInvoice = response.data.data
                    this.$router.push("/invoices")
                    return resolve("success")
                  } else {
                    Swal.fire({
                      icon: 'info',
                      title: 'Failed',
                      text: response.data.narrative,
                      footer: '<a href=""></a>'
                    })
                    return reject(response.data.narrative)
                  }
                })
                .catch(e => {
                  if (e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
                    return
                  }
                  return reject("Error occurred 9")
                })
                .finally(() => {
                })
            })
          }
        }
      })
    },
    viewInvoicePayments() {
      this.$router.push(`/invoices/${this.invoiceId}/payments`);
    },
    editInvoice(id) {
      this.$router.push(`/invoices/${id}/edit`);
    },
  },
  async mounted() {
    if (!this.currentUser) {
      await this.$router.push('/login')
      return
    }

    this.invoiceId = this.$route.params.id;

    this.invoiceTabs = viewInvoiceTabs(this.invoiceId)
    this.modules = allowedModules.filter(module => module.name === this.$i18n.locale)[0].modules;

    await this.retrieveInvoice(this.invoiceId);

    let invoice = invoice ? JSON.parse(localStorage.getItem('viewQuotation')) : this.invoice
    if (invoice) {
      this.invoice = invoice
    } else {
      let price = (Math.round(0.00).toFixed(2));
      let invoiceLine = {sku: "", quantity: "1", description: "", price: price, subTotal: 1.00}
      this.invoice.products.push(invoiceLine)
    }

    const attributes = document.querySelectorAll('.formContainer');
    attributes.forEach(attribute => {
      attributes.classList.remove('input');
    });

    this.payment.date = this.getCurrentDate()
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed
}

.cards thead {
  display: none;
}

.cards tr {
  display: flex;
  flex-direction: column;

  margin-bottom: 5px !important;
  /*border: 1px solid navajowhite !important;*/
  border: 1px solid rgba(0, 0, 0, 0.1) !important;;
}

.cards tr > th {
  display: none;
}

.hide-on-mobile {
  display: none;
}

.cards tr > td::before {
  content: attr(col) '';
  font-weight: bold;
}

.white-space {
  width: 200px;
}

.pre-line {
  white-space: pre-line;
}

.w99 {
  width: 100%;
  border: none white;
}

.w101 {
  width: 100%;
  height: 35px;
  border: none white;
}

.printBoarder {
  border: 1px solid lightgray;
  border-radius: 5px;
}


.tblItems thead tr th {
  padding: 0.50rem !important;
}

.tblItems tbody tr td {
  padding: 0.30rem !important;
}


.tblTotals tbody tr td {
  padding: 0.30rem !important;
}

.tblTotals tr.borderless td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0);
}

.tblTotals tbody tr {
  border-bottom: 0 solid rgba(0, 0, 0, 0.0);
}

tr.noBorder td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0.05);
  background-color: #f5f5f5;
}


.tblPayments tr.borderless td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0);
}

.tblPayments tbody tr td {
  padding: 0.50rem !important;
}

.tblPayments tbody tr {
  border-bottom: 0 solid rgba(0, 0, 0, 0.0);
}


.tblInvoiceHeaderDetails tr.borderless td {
  border: 0;
  border-bottom: 0 rgba(0, 0, 0, 0);
}

.tblInvoiceHeaderDetails tbody tr td {
  padding: 0.20rem !important;
}

.tblInvoiceHeaderDetails tbody tr {
  border-bottom: 0 solid rgba(0, 0, 0, 0.0);
}

@media print {
  .hidden-print,
  .hidden-print * {
    display: none !important;
  }

  #items-header {
    background-color: black;
    color: white;
  }

  .no-print {
    display: none !important;
  }

  .result {
    height: 100%;
    overflow: visible;
  }

  .printBoarder {
    border: none !important;
    border-radius: 0 !important;
  }
}

.description-mobile {
  text-align: left;
}

.title-mobile {
  text-align: center;
}

.total-mobile {
  text-align: right;
}

@media screen and (max-width: 767px) {
  .description-mobile {
    background-color: #666;
    color: white;
  }

  .title-mobile, .description-mobile, .total-mobile {
    text-align: left;
    display: flex;
    justify-content: space-between
  }
}

@media only screen and (max-width: 900px) {

  .quote-header {
    display: none;
  }

  #printMe {
    width: 100%;
    height: 100%;
  }

  .invoice-wrapper {
    margin-top: 16px;
    margin-left: 0;
    margin-right: 0
  }
}
</style>



// WEBPACK FOOTER //
// src/components/invoices/ViewInvoiceOffline.vue